export const formatTeamInviteRequest = (data: any): any => {
  return {
    ...data
  };
};
